<template>
  <div class="searchAreaStyle d-flex align-center">
    <div class="titleStyle font-weight-bold pl-10">
      {{ $t(selectBoxInfo.target) }}
    </div>

    <div v-if="isEdit" class="pl-16">
      {{ target }}
    </div>
    <span v-else class="d-flex align-center">
      <div class="original-selectbox selectBoxStyle">
        <NormalCombobox
          v-model="selectClientName"
          :items="selectBoxInfo.clientNameList"
          height="32px"
        />
      </div>

      <NormalButton
        :text="$t('order.order_narrow-down-button')"
        height="32px"
        width="120px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="historySearch"
      />
      <HistorySearchDialog
        v-model="dialog.historySearch"
        :selectClientName="selectClientName"
        :target="selectBoxInfo.target"
        :comboboxList="selectBoxInfo.clientNameList"
        :tableData="history"
        @reflect="reflect"
        @change="changeHistorySearch"
      />

      <NormalTextButton
        :text="'＋ ' + $t(selectBoxInfo.target) + $t('common.common_register')"
        class="textButtonStyle"
        @click="dialog.registerMaster = true"
      />
      <MasterDialog
        v-model="dialog.registerMaster"
        @success="registerMasterSuccess()"
      />
    </span>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import {
  NormalButton,
  NormalTextButton,
  NormalCombobox
} from '@/components/items'

import HistorySearchDialog from '@/components/layouts/Dialogs/HistorySearchDialog'
import MasterDialog from '@/components/layouts/Dialogs/Master/Supplier/MasterSupplierDialog'

export default {
  components: {
    NormalButton,
    NormalTextButton,
    NormalCombobox,
    HistorySearchDialog,
    MasterDialog
  },
  props: {
    target: { default: '' },
    selectClientUnderLackStock: {}
  },
  data: () => ({
    isEdit: false,

    selectClientName: {
      label: '',
      value: null
    },
    historySelectData: {
      selectClientName: {
        label: '',
        value: null
      },
      radioGroup: ''
    },
    selectBoxInfo: {
      target: 'product.product_supplier',
      clientId: 'supplierId',
      clientNameList: []
    },
    history: {
      headers: [
        {
          value: 'radioBtn',
          width: '55px',
          filterable: false,
          align: 'center'
        },
        {
          value: 'supplierId',
          align: ' d-none'
        },
        {
          text: 'order.order_order-date',
          value: 'orderDate',
          width: '100px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'sale.sale_completion-date',
          value: 'compDate',
          width: '100px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'order.order_order-number',
          value: 'transaction.controlNumber',
          width: '220px',
          filterable: false,
          align: 'center'
        },

        {
          text: 'sale.sale_author',
          value: 'user',
          width: '100px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'common.input_currency',
          value: 'currencyId',
          width: '80px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'sale.sale_price',
          value: 'amount',
          width: '144px',
          filterable: false,
          align: 'end'
        }
      ],
      itemKey: 'orderId',
      items: []
    },
    dialog: {
      historySearch: false,
      registerMaster: false
    }
  }),
  async created() {
    this.isEdit = this.target ? true : false
    if (this.isEdit) return

    await this.init(false)
  },

  methods: {
    ...mapActions('Common', ['getCountryListFromApi']),
    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),
    ...mapActions('Order', ['getOrderListFromApi']),
    ...mapGetters('Order', ['getOrderListFromState']),

    getHistoryListFromState() {
      return this.getOrderListFromState()
    },
    getClientListFromState() {
      return this.getSuppliersFromState()
    },

    async getClientData(isHistorySearch, selectClientNameValue) {
      return await Promise.all([
        this.getSuppliersFromApi(),
        isHistorySearch
          ? this.getOrderListFromApi({
              invalidOrderDisplay: 0,
              supplierIds: selectClientNameValue
            })
          : null
      ]).then((message) => {
        return [
          this.getClientListFromState()
            .filter((ele) => {
              return ele.isEnabled
            })
            .map((ele) => {
              return {
                label: ele.name,
                value: ele[this.selectBoxInfo.clientId]
              }
            }),
          isHistorySearch ? this.getHistoryListFromState() : []
        ]
      })
    },

    async changeHistorySearch(...args) {
      const [selectClientNameValue] = args
      await this.getOrderListFromApi({
        invalidOrderDisplay: 0,
        supplierId: selectClientNameValue
      })
      this.history.items = this.getHistoryListFromState()
    },
    async registerMasterSuccess() {
      await this.getCountryListFromApi()
      await this.init(false)
      this.dialog.registerMaster = false
    },

    async init(isHistorySearch) {
      const [clientNameList, historyList] = await this.getClientData(
        isHistorySearch,
        this.selectClientName.value
      )

      this.selectBoxInfo.clientNameList = clientNameList
      this.history.items = historyList
    },

    async historySearch() {
      if (!this.selectClientName.value) {
        alert(
          this.$t(this.selectBoxInfo.target) +
            this.$t('common.common_input-select')
        )
        return
      }
      await this.init(true)
      this.dialog.historySearch = true
    },

    reflect(...args) {
      const [selectClientName, radioGroup] = args

      const history = this.getHistoryListFromState().find(
        (ele) =>
          ele[this.selectBoxInfo.clientId] === selectClientName.value &&
          ele[this.history.itemKey] === radioGroup
      )
      const clientData = this.getClientListFromState().find(
        (ele) => ele[this.selectBoxInfo.clientId] === selectClientName.value
      )
      history.recipients = clientData ? clientData.recipients : []

      this.historySelectData = {
        selectClientName: selectClientName,
        radioGroup: radioGroup
      }
      this.selectClientName = selectClientName

      this.$emit('change', 'history', this.history.itemKey, history)
    }
  },
  watch: {
    selectClientName: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.historySelectData.selectClientName.value !== newVal.value) {
          if (!newVal.value) {
            this.$emit('change', 'select', this.selectBoxInfo.clientId, {})
            return
          }

          this.historySelectData = {
            selectClientName: { label: '', value: null },
            radioGroup: ''
          }

          const clientData = this.getClientListFromState().find(
            (ele) => ele[this.selectBoxInfo.clientId] === newVal.value
          )
          this.$emit(
            'change',
            'select',
            this.selectBoxInfo.clientId,
            clientData
          )
        }
      }
    },
    selectClientUnderLackStock: {
      deep: true,
      handler(newVal) {
        if (!newVal) return
        this.selectClientName = newVal
      }
    }
  }
}
</script>
<style scoped lang="scss">
.searchAreaStyle {
  height: 70px;

  .titleStyle {
    font-size: 18px;
  }

  .selectBoxStyle {
    width: 340px;
    margin: 0px 16px 0px 63px !important;
  }

  .textButtonStyle {
    margin: 0px 21px;
  }
}
</style>
